<template>
  <!-- 公司信息网站底部 -->

  <div>
    <div class="footer">
      <div class="fall">
        <div class="fleft">
          <h3>公司介绍</h3>
          <p @click="gsjj('公司简介')">公司简介</p>

          <p @click="gsjj('主要领导介绍')">组织结构</p>
          <p @click="gsjj('App功能简介')">App功能简介</p>
          <p @click="gsjj('成果展示')">成果展示</p>
        </div>
        <div class="fleft">
          <h3>联系我们</h3>
          <p @click="lxwm('加入我们')">加入我们</p>
          <p @click="lxwm('联系方式')">联系方式</p>
          <p @click="lxwm('留言板')">留言板</p>
          <p style="visibility: hidden">1</p>
        </div>
        <div class="fleft1">
          <h3>联系方式</h3>
          <p>电话：010-6290-6806</p>
          <p>邮箱：dnt2022@163.com</p>
          <p style="visibility: hidden">1</p>
          <p style="visibility: hidden">1</p>
        </div>
        <div class="fright">
          <div style="visibility: hidden">
            <p style="visibility: hidden">1</p>
          </div>
          <div>
            <p style="visibility: hidden">1</p>
          </div>
        </div>
      </div>
      <h1>
        Copyright ©2026 北京点奈特医疗科技有限公司版权所有 |
        <el-link
          style="color: #fff; font-size: 0.8rem; padding-bottom: 0.2rem"
          :underline="false"
          href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank"
          >
          ICP经营许可证:京ICP备2021021341号
        </el-link>
      </h1>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  name: "Home",
  data() {
    return {};
  },
  mounted() {
    new this.$wow.WOW().init();
  },
  methods: {
    //公司简介
    gsjj(item) {
      this.$store.commit("subset", "");
      this.$router.push({ name: "gsjj", params: { lx: item } });
      this.$store.commit("subset", item);
    },
    lxwm(item) {
      this.$store.commit("zxxixvt", "");
      this.$router.push({ name: "ContactUs", params: { lx: item } }, () => {});
      this.$store.commit("zxxixvt", item);
    },
  },

  watch: {},
};
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  background-image: url(../../assets/sy/Copyright\ ©2018\ 北京蔚来高科技术有限公司（www.bjwlgk.com）\ 版权所有\ _\ ICP经营许可证-京I.png);
  background-size: 100%;
  height: 100%;

  .fall {
    margin: auto;
    padding-top: 0.5rem;
    display: flex;
    color: #fff;
    // justify-content: space-around;
    align-items: center;
    margin-left: 10rem;

    .fleft1 {
      margin-left: 10rem;

      p {
        font-size: 1.125rem;
        font-weight: 400;
        margin-top: 2rem;
        font-family: Microsoft YaHei;
        line-height: 18px;
      }
    }

    .fleft {
      margin-left: 10rem;

      p {
        font-size: 1.125rem;
        font-weight: 400;
        margin-top: 2rem;
        font-family: Microsoft YaHei;
        line-height: 18px;
      }

      p:hover {
        font-size: 1.125rem;
        font-weight: 400;
        margin-top: 2rem;
        font-family: Microsoft YaHei;
        line-height: 18px;
        color: #296cbf;
        cursor: pointer;
        /*悬停变小手的属性*/
      }
    }

    .fright {
      margin-left: 5rem;
      text-align: center;
      display: flex;

      img {
        width: 8rem;
        height: 8rem;
        margin-top: -2rem;
        // margin-left: 1rem;
      }

      p {
        font-size: 1.125rem;
        margin-left: 10px;
      }
    }
  }

  h1 {
    font-size: 0.8rem;
    text-align: center;
    padding-bottom: 0.5rem;
    color: #fff;
    margin-top: -10px;
    font-weight: 400;
    font-family: Microsoft YaHei;
  }
}
</style>
